import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('group', '/plans/groups', 'group')
const actions = generator.generate()

export default actions
